/**
 * @generated SignedSource<<2ac4c494afee020e97260ca541dddc9e>>
 * @relayHash 02c9d1d19da3e8f6b3b9cf86306cbd33
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 02c9d1d19da3e8f6b3b9cf86306cbd33

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commercialManagerEmail"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "commercialManagerEmail",
        "variableName": "commercialManagerEmail"
      },
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "BasicResponse",
    "kind": "LinkedField",
    "name": "accountUpdateCommercialManager",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountUpdateCommercialManagerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountUpdateCommercialManagerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "02c9d1d19da3e8f6b3b9cf86306cbd33",
    "metadata": {},
    "name": "AccountUpdateCommercialManagerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "b3560253c670030a56b7e066dced5785";

export default node;
